export const enum KEYS {
  C = 'C',
  X = 'X',
  Z = 'Z',
  Y = 'Y',
  A = 'A',
  G = 'G',
  L = 'L',
  F = 'F',
  D = 'D',
  B = 'B',
  P = 'P',
  MINUS = '-',
  EQUAL = '=',
  DIGIT_0 = '0',
  DELETE = 'DELETE',
  UP = 'ARROWUP',
  DOWN = 'ARROWDOWN',
  LEFT = 'ARROWLEFT',
  RIGHT = 'ARROWRIGHT',
  ENTER = 'ENTER',
  SPACE = ' ',
  TAB = 'TAB',
  BACKSPACE = 'BACKSPACE',
  ESC = 'ESCAPE',
  PAGEUP = 'PAGEUP',
  PAGEDOWN = 'PAGEDOWN',
  F5 = 'F5',
}

export const HOTKEY_DOC = [
  {
    type: 'hotkey.opt.common',//通用
    children: [
      { label: 'hotkey.opt.ctrlX', value: 'Ctrl + X' },
      { label: 'hotkey.opt.ctrlC', value: 'Ctrl + C' },
      { label: 'hotkey.opt.ctrlV', value: 'Ctrl + V' },
      { label: 'hotkey.opt.ctrlD', value: 'Ctrl + D' },
      { label: 'hotkey.opt.ctrlA', value: 'Ctrl + A' },
      { label: 'hotkey.opt.ctrlZ', value: 'Ctrl + Z' },
      { label: 'hotkey.opt.ctrlY', value: 'Ctrl + Y' },
      { label: 'hotkey.opt.del', value: 'Delete / Backspace' },
      { label: 'hotkey.opt.ctrlMore', value: 'Ctrl / Shift' },
      { label: 'hotkey.opt.ctrlP', value: 'Ctrl + P' },
      { label: 'hotkey.opt.esc', value: 'ESC' },
    ],
  },
  {
    type: 'hotkey.slide.show',
    children: [
      { label: 'hotkey.slide.first', value: 'F5' },
      { label: 'hotkey.slide.current', value: 'Shift + F5' },
      { label: 'hotkey.slide.spacePre', value: '↑ / ← / PgUp' },
      { label: 'hotkey.slide.spaceNext1', value: '↓ / → / PgDown' },
      { label: 'hotkey.slide.spaceNext2', value: 'Enter / Space' },
      { label: 'hotkey.slide.out', value: 'ESC' },
    ],
  },
  {
    type: 'hotkey.slide.edit',
    children: [
      { label: 'hotkey.slide.new', value: 'Enter' },
      // { label: 'hotkey.slide.move', value: 'Space + 鼠标拖拽' },
      // { label: 'hotkey.slide.upOrDown', value: 'Ctrl + 鼠标滚轮' },
      { label: 'hotkey.slide.up', value: 'Ctrl + =' },
      { label: 'hotkey.slide.down', value: 'Ctrl + -' },
      { label: 'hotkey.slide.screen', value: 'Ctrl + 0' },
      { label: 'hotkey.slide.noSelectPrePage', value: '↑ / ←' },
      { label: 'hotkey.slide.noSelectNextPage', value: '↓ / →' },
      { label: 'hotkey.slide.prePage', value: 'PgUp' },
      { label: 'hotkey.slide.nextPage', value: 'PgDown' },
    ],
  },
  {
    type: 'hotkey.element.opt',
    children: [
      { label: 'hotkey.element.move', value: '↑ / ← / ↓ / →' },
      { label: 'hotkey.element.lock', value: 'Ctrl + L' },
      { label: 'hotkey.element.combo', value: 'Ctrl + G' },
      { label: 'hotkey.element.cancelCombo', value: 'Ctrl + Shift + G' },
      { label: 'hotkey.element.top', value: 'Alt + F' },
      { label: 'hotkey.element.bottom', value: 'Alt + B' },
      { label: 'hotkey.element.h', value: 'Ctrl / Shift' },
      { label: 'hotkey.element.v', value: 'Ctrl / Shift' },
      { label: 'hotkey.element.change', value: 'Tab' },
      { label: 'hotkey.element.com', value: 'Enter' },
    ],
  },
  {
    type: 'hotkey.table.edit',
    children: [
      { label: 'hotkey.table.nextCol', value: 'Tab' },
      { label: 'hotkey.table.insertTop', value: 'Ctrl + ↑' },
      { label: 'hotkey.table.insertBottom', value: 'Ctrl + ↓' },
      { label: 'hotkey.table.insertLeft', value: 'Ctrl + ←' },
      { label: 'hotkey.table.insertRight', value: 'Ctrl + →' },
    ],
  },
  {
    type: 'hotkey.chat.edit',
    children: [
      { label: 'hotkey.chat.nextLine', value: 'Enter' },
    ],
  },
  {
    type: 'hotkey.text.edit',
    children: [
      { label: 'hotkey.text.bold', value: 'Ctrl + B' },
      { label: 'hotkey.text.italics', value: 'Ctrl + I' },
      { label: 'hotkey.text.underline', value: 'Ctrl + U' },
      { label: 'hotkey.text.delLine', value: 'Ctrl + D' },
    ],
  },
]